export default __webpack_public_path__ + "static/media/grow-green.0da68e78.svg";